import { render, staticRenderFns } from "./WarehouseOrBranch.vue?vue&type=template&id=c20b1e16&scoped=true&"
import script from "./WarehouseOrBranch.vue?vue&type=script&lang=js&"
export * from "./WarehouseOrBranch.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseOrBranch.vue?vue&type=style&index=0&id=c20b1e16&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20b1e16",
  null
  
)

export default component.exports